export function addRecordFileToFormData(file, formData) {
    formData.append('_id', file._id);
    formData.append('createdTimestamp', file.createdTimestamp);
    formData.append('author[_id]', file.author._id);
    formData.append('filename', file.filename);
    if (file.mimeType) {
        formData.append('mimeType', file.mimeType);
    }
    formData.append('filesize', file.filesize);
    formData.append('fileSignature', file.fileSignature);
    if (file.signature) {
        formData.append('signature[value]', file.signature.value);
        formData.append('signature[keyId]', file.signature.keyId);
        formData.append('signature[method]', file.signature.method);
    }
}
//# sourceMappingURL=FileUtils.js.map